module.exports = __webpack_public_path__ + "img/squishiland-bg.9399acdd.png";